import { parseYouTubeVideoId } from './youtube.js';
const CHANNEL_PATTERNS = [
    /^https?:\/\/(?:www\.)?youtube\.com\/(channel\/[A-Za-z0-9_-]+)/i,
    /^https?:\/\/(?:www\.)?youtube\.com\/(@[A-Za-z0-9_.-]+)/i,
    /^https?:\/\/(?:www\.)?youtube\.com\/(c\/[A-Za-z0-9_-]+)/i,
    /^https?:\/\/(?:www\.)?youtube\.com\/(user\/[A-Za-z0-9_-]+)/i,
];
const PLAYLIST_PATTERN = /[?&]list=([A-Za-z0-9_-]+)/;
/**
 * The legacy custom URL: `youtube.com/trtcocuk`, with no `@`, `c/` or `user/`.
 *
 * Still the address printed on posters and still what a parent pastes. It is
 * matched last and only after everything at the root of youtube.com that is
 * *not* a channel has been ruled out, because a single path segment there is
 * ambiguous by design — `watch`, `playlist` and `feed` live in the same place.
 */
const NOT_A_CHANNEL_NAME = new Set([
    'watch',
    'playlist',
    'feed',
    'results',
    'shorts',
    'live',
    'embed',
    'hashtag',
    'account',
    'gaming',
    'premium',
    'about',
    'howyoutubeworks',
    't',
    'v',
]);
const LEGACY_NAME_PATTERN = /^https?:\/\/(?:www\.)?youtube\.com\/([A-Za-z0-9_.-]+)\/?(?:[?#].*)?$/i;
export const resolveImportSource = (input) => {
    const trimmed = input.trim();
    if (trimmed === '') {
        return null;
    }
    for (const pattern of CHANNEL_PATTERNS) {
        const match = pattern.exec(trimmed);
        if (match?.[1] !== undefined) {
            // The `/videos` tab, always — even when the parent pasted a bare channel
            // URL or one already pointing at some other tab.
            return {
                kind: 'YOUTUBE_CHANNEL',
                url: `https://www.youtube.com/${match[1]}/videos`,
            };
        }
    }
    // A playlist is checked before a single video, because a watch URL opened
    // from inside a playlist carries both and the playlist is the larger intent.
    const playlist = PLAYLIST_PATTERN.exec(trimmed);
    if (playlist?.[1] !== undefined) {
        return {
            kind: 'YOUTUBE_PLAYLIST',
            url: `https://www.youtube.com/playlist?list=${playlist[1]}`,
        };
    }
    const videoId = parseYouTubeVideoId(trimmed);
    if (videoId !== null) {
        return { kind: 'YOUTUBE_VIDEO', url: `https://www.youtube.com/watch?v=${videoId}` };
    }
    // Last, so that anything with a recognisable shape has already been claimed.
    const legacy = LEGACY_NAME_PATTERN.exec(trimmed);
    const name = legacy?.[1];
    if (name !== undefined && !NOT_A_CHANNEL_NAME.has(name.toLowerCase())) {
        return { kind: 'YOUTUBE_CHANNEL', url: `https://www.youtube.com/${name}/videos` };
    }
    return null;
};
//# sourceMappingURL=import-source.js.map